var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',{staticClass:"flex-col mb-4"},[_c('column',{staticClass:"w-full"},[_c('main-title',{staticClass:"pb-0"},[_vm._v("\n      "+_vm._s(_vm.$t('organisms.checkout_header.title'))+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }